export * from './list';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/list/index.js
// module id = 378
// module chunks = 3